import React from "react";

export default function PoliticaPrivacidade() {
  return (
    <div className="bg-slate-50 min-h-screen pt-32 pb-16 text-slate-800">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-extrabold text-slate-900 mb-8">
          Política de Privacidade
        </h1>
        <div className="bg-white p-8 rounded-lg shadow-sm border border-slate-200 space-y-6 text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">
              1. Introdução
            </h2>
            <p>
              A Envisio respeita a sua privacidade e está empenhada em proteger os
              seus dados pessoais. Esta política descreve como recolhemos, utilizamos,
              partilhamos e protegemos a informação que nos fornece através do nosso
              website.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">
              2. Recolha de Dados
            </h2>
            <p>
              Recolhemos informações pessoais apenas quando estas são fornecidas
              voluntariamente, como nome, endereço de e-mail e número de telefone, ao
              preencher formulários de contacto, subscrições de newsletters ou na
              inscrição em cursos da Academia Envisio.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">
              3. Utilização da Informação
            </h2>
            <p>
              Os dados recolhidos são utilizados para processar as suas solicitações,
              fornecer informações sobre os nossos serviços e formações, melhorar a
              sua experiência no website e para efeitos de marketing, caso tenha dado
              o seu consentimento explícito.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">
              4. Partilha de Dados
            </h2>
            <p>
              Não vendemos, alugamos nem partilhamos as suas informações pessoais
              com terceiros, exceto quando necessário para a prestação de serviços
              solicitados por si ou quando exigido por lei.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">
              5. Segurança
            </h2>
            <p>
              Implementamos medidas de segurança técnicas e organizativas adequadas
              para proteger os seus dados pessoais contra acesso não autorizado, perda,
              destruição ou alteração indevida.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">
              6. Direitos do Utilizador
            </h2>
            <p>
              Tem o direito de aceder, corrigir ou solicitar a eliminação dos seus dados
              pessoais a qualquer momento. Para exercer estes direitos, por favor contacte-nos
              através do e-mail geral@envisio.co.ao.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">
              7. Cookies
            </h2>
            <p>
              Utilizamos cookies para melhorar a navegação e personalizar o conteúdo. Ao
              continuar a navegar no nosso website, concorda com a utilização destas
              tecnologias.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
